import { Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '../../styles/CommonStyles';

const cellStyle: React.CSSProperties = { cursor: 'default', ...CommonStyles.Layout.FlexBlockLeftAndCenter };

const countStyle: React.CSSProperties = {
  color: CommonStyles.Colors.Grey153,
  flex: 'none',
  marginLeft: CommonStyles.Sizes.DefaultSpace
};

export const CountPill: React.FC<{ count: string, onClick?: React.MouseEventHandler }> = ({ count, ...restProps }) =>
  <span
    data-tb-test-id="data-grid-cell-count"
    style={{ ...countStyle, ...(restProps.onClick && { cursor: 'pointer' }) }}
    {...restProps}
  >
    {count}
  </span>;

export type CellWithCountProps = { count?: string, testId?: string };
export const CellWithCountPill: React.FC<CellWithCountProps & { onCountClick?: () => void }> = props => {
  return (
    <span data-tb-test-id={props.testId} style={cellStyle}>
      {props.children}
      {props.count && <CountPill count={props.count} onClick={props.onCountClick} />}
    </span>
  );
};

export const CellWithCountAndToolTip: React.FC<CellWithCountProps & { getPopoverContent: () => Promise<JSX.Element> }> = props => {
  return (
    <span data-tb-test-id={props.testId} style={cellStyle}>
      {props.children}
      {props.count &&
        <Tooltip getContent={props.getPopoverContent} position={TooltipPosition.Right}>
          <CountPill count={props.count} />
        </Tooltip>
      }
    </span>
  );
};
